var Usersession = (function(){
var user_code ="";
var prop_code ="";
var user_cityid ="";
var postexpdays ="0";
var chatcode = {chatid:0,code:'',ctype:''}
var srchcopts = {contryid:"1",ctid:"1",localid:"1",trnstpid:"1",protype:"1",postedby:"1"};
var prop_ptype = "";
var user_ptypeid = "7";

var guest_mailid = "";
var getChatcode = function(){
return chatcode;
};
var setChatcode = function(code: any){
chatcode = code;
};

var getPostexpdays = function(){
return postexpdays;
};
var setPostexpdays = function(code: any){
postexpdays = code;
};

var getGuestmailid = function(){
return guest_mailid;
};
var setGuestmailid = function(code: any){
guest_mailid = code;
};


var getUsertypeid = function(){
return user_ptypeid;
};
var setUsertypeid = function(code: any){
user_ptypeid = code;
};


var getProcode = function(){
return prop_code;
};
var setProcode = function(code: any){
prop_code = code;
};
var getType = function(){
return prop_ptype;
};
var setType = function(code: any){
prop_ptype = code;
};

var getCode = function(){
return user_code;
};
var setCode = function(code: any){
user_code = code;
};
var getCityId = function(){
return user_cityid;
};
var setCityId = function(uctid: any){
user_cityid = uctid;
};
var getSearchopts = function(){
return srchcopts;
};
var setSearchopts = function(opts: any){
srchcopts = opts;
};


return{
getCode: getCode,
setCode: setCode,
getCityId: getCityId,
setCityId: setCityId,
getSearchopts: getSearchopts,
setSearchopts:setSearchopts,
getType:getType,
setType:setType,
getProcode:getProcode,
setProcode:setProcode,
getUsertypeid:getUsertypeid,
setUsertypeid:setUsertypeid,
getGuestmailid:getGuestmailid,
setGuestmailid:setGuestmailid,
getPostexpdays:getPostexpdays,
setPostexpdays:setPostexpdays,
getChatcode:getChatcode,
setChatcode:setChatcode

}
})();
export default Usersession;